module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"legend-item\">\n    <div class=\"title\">")
    ; __append(escapeFn( legend.title))
    ; __append("</div>\n    <table style=\"margin: 10px 0;\"><tr>\n        <td>\n            ")
    ;  var height = 100;
            var step = 100 / (legend.items.length-1);
            var gradient = _.reduce(legend.items, function(reducer, item, key) {
                reducer.push(item['color']+' '+(key*step)+'%')
                return reducer;
            }, []).join(', '); 
    ; __append("\n            <span style=\"display: inline-block;\n                    background: -moz-linear-gradient(bottom,  ")
    ; __append(escapeFn( gradient ))
    ; __append("); /* FF3.6-15 */\n                    background: -webkit-linear-gradient(bottom, ")
    ; __append(escapeFn( gradient ))
    ; __append("); /* Chrome10-25,Safari5.1-6 */\n                    background: linear-gradient(to top, ")
    ; __append(escapeFn( gradient ))
    ; __append("); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n                    width: 30px;\n                    height: ")
    ; __append(escapeFn(height))
    ; __append("px;\n                    margin-right: 0.3em;\n                    border: 1px solid #222222;\"></span>\n        </td>\n        <td style=\"position: relative\">\n            ")
    ;   var step = height / (legend.items.length-1);
            _.each(_.reverse(legend.items), function(item, key) { 
    ; __append("\n                <span style=\"position: absolute;\n                        top: ")
    ; __append(escapeFn( key*step-8 ))
    ; __append("px\">")
    ; __append(escapeFn( item.title ))
    ; __append("</span>\n            ")
    ;  }) 
    ; __append("\n        </td>\n    </tr></table>\n\n</div>")
  }
  return __output.join("");

}